export const columnListDefault = [
  { type: 'seq', title: '序号', width: 50 },
  {
    field: 'projectNo',
    title: '维修项目编号',
    visible: true,
  },
  {
    field: 'typeStr',
    title: '维修类型',
    visible: true,
  },
  {
    field: 'content',
    title: '维修内容',
    visible: true,
  },
  {
    field: 'checkPersonName',
    title: '验收人',
    visible: true,
    editRender: {
      name: 'input',
      props: {
        clearable: true,
        placeholder: '请输入验收人',
      },
    },
  },
  {
    field: 'checkDate',
    title: '验收时间',
    visible: true,
    editRender: {
      name: 'datePicker',
      type: 'date',
      // attrs: { type: 'date' },
    },
  },
  {
    field: 'checkDesc',
    title: '验收说明',
    visible: true,
    editRender: {
      name: 'input',
    },
  },
];
